import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { IoInformationCircle } from "react-icons/io5";
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert'; // Import Alert component
import { FaPencilAlt } from "react-icons/fa";
import { FaSimplybuilt } from "react-icons/fa6";
import axios from '../../Authservices/axiosInstance';
import './edit-department.css';

export default function EditDepartments() {
  const { id } = useParams(); // Get the department ID from the URL
  const [formData, setFormData] = useState({
    name: '', // Assuming the field name should be 'name' based on context
  });
  const [showAlert, setShowAlert] = useState(false); // State for alert visibility
  const navigate = useNavigate(); // Hook to programmatically navigate

  // Fetch the department data when the component mounts
  useEffect(() => {
    const fetchDepartment = async () => {
      try {
        const response = await axios.get(`https://backend.ems.uk.hiradentallab.com/api/departments/${id}`); // Adjust URL as necessary
        setFormData({
          name: response.data.name || '', // Set the name field from the fetched data
        });
      } catch (error) {
        console.error('Error fetching department:', error);
        alert('Failed to fetch department details');
      }
    };

    fetchDepartment();
  }, [id]);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put(`https://backend.ems.uk.hiradentallab.com/api/departments/update/${id}`, {
        name: formData.name,
      });
      console.log('Department updated successfully:', response.data);
      setShowAlert(true); // Show alert on successful update
      setTimeout(() => {
        setShowAlert(false); // Hide alert after 3 seconds
        navigate('/departments'); // Redirect after successful update
      }, 3000);
    } catch (error) {
      console.error('Error updating department:', error);
      alert(error.response?.data?.message || 'An error occurred while updating the department.'); // Show backend error
    }
  };

  return (
    <div>
      <div>
        <h1 className="edit-department-title">
          <IoInformationCircle className="salary-icon" /> Departments Information
        </h1>
        <hr />
        <h2 className="edit-department-subtitle">
          <FaSimplybuilt className="salary-icon" /> Edit Department Details
        </h2>
        <hr />

        <div className="table-container">
          {showAlert && ( // Conditional rendering for alert
            <Alert variant="success" onClose={() => setShowAlert(false)} dismissible>
              Department updated successfully!
            </Alert>
          )}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name" style={{ fontWeight: 'bold' }}>
                Department Name <span style={{ color: 'red' }}> *</span>
              </label>
              <textarea
                id="name" // Changed id to 'name' for clarity
                name="name" // Changed name to 'name' for clarity
                className="form-control"
                value={formData.name}
                onChange={handleChange}
                required
                style={{ height: '20px', width: '40%' }} // Adjust this value as needed
              ></textarea>
            </div>

            <div className="py-3">
              <Button variant="primary" type="submit">
                <FaPencilAlt /> Update Department
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
